import classNames from 'classnames';

import Avatar from '~components/Avatar';
import Button from '~components/Button';
import Bookmark from '~components/Icon/Bookmark';
import Close from '~components/Icon/Close';
import ModalBase, { ModalBaseProps } from '~components/ModalBase';
import useMyInfoQuery from '~hooks/query/user/useMyInfoQuery';
import useLogout from '~hooks/useLogout';
import useMoveOneIdPage from '~hooks/useMoveOneIdPage';
import { setVisitedMypageToStorage } from '~utils/browser/visitedMypage';

import { GNB_MAIN_MENU, GNB_SESSION_MENU } from '../constants';
import GnbItem from '../GnbItem';
import * as HeaderStyle from '../style';
import * as S from './style';

interface Props extends ModalBaseProps {
  handleClose: (gnbId?: string) => void;
}

export default function ModalGnbMenu({ isOpen, handleClose }: Props) {
  const { data: myInfoData, isActiveUser } = useMyInfoQuery();
  const moveOneIdPage = useMoveOneIdPage();
  const handleLogout = useLogout();

  const handleClickGnb = (gnbId: string) => {
    if (gnbId !== 'bookmark' && gnbId !== 'companylist') {
      handleClose(gnbId);
    }

    // logout
    if (gnbId === 'logout') {
      handleLogout({ reload: true });
    }
  };

  return (
    <ModalBase isOpen={isOpen} handleClose={handleClose} inlineCss={S.cssModalWrapper} maskClosable>
      <S.Header as='div'>
        <HeaderStyle.InnerWrapper>
          <S.ButtonClose onClick={() => handleClose()}>
            <Close />
          </S.ButtonClose>
        </HeaderStyle.InnerWrapper>
      </S.Header>
      <S.ContentsWrapper>
        {isActiveUser ? (
          <S.LoggedWrapper>
            <S.ProfileWrapper>
              <S.AvatarWrapper>
                <Avatar size={48} thumbnail={myInfoData?.profileUrl} />
              </S.AvatarWrapper>
              <S.UserName>
                <strong>{myInfoData?.name}</strong>님
              </S.UserName>
            </S.ProfileWrapper>

            <S.LoggedGnbWrapper>
              {GNB_SESSION_MENU.map((item) => (
                <S.LoggedGnbItem
                  className={classNames({
                    bookmark: item.id === 'bookmark',
                    mypage: item.id === 'mypage',
                  })}
                  key={item.id}
                  data-attribute-id='gnb'
                  data-gnb-kind={item.gnbKind}
                  gnbId={item.id}
                  href={item.href}
                  target={item.target}
                  gnbKind={item.gnbKind}
                  isNew={item.isNew}
                  onClick={() => handleClickGnb(item.id)}>
                  {item.id === 'bookmark' ? (
                    <>
                      <span>
                        <Bookmark width={14} />
                      </span>
                      {item.label}
                    </>
                  ) : (
                    <span>{item.label}</span>
                  )}
                </S.LoggedGnbItem>
              ))}
            </S.LoggedGnbWrapper>
          </S.LoggedWrapper>
        ) : (
          <S.UnloggedWrapper>
            <S.LoginMessage>
              로그인 후 스크랩을 이용하면
              <br />
              여러 기업을 한번에 비교해볼 수 있어요.
            </S.LoginMessage>
            <S.ButtonWrapper>
              <Button
                size='md'
                variant='magenta'
                data-attribute-id='gnb'
                data-gnb-kind='signupLogin'
                onClick={() => moveOneIdPage()}>
                로그인/회원가입
              </Button>
            </S.ButtonWrapper>
          </S.UnloggedWrapper>
        )}

        <S.TitleMenu>메뉴</S.TitleMenu>
        <S.Menu>
          {GNB_MAIN_MENU.map((item) => (
            <S.MenuItem key={item.id} gnbId={item.id}>
              <GnbItem
                gnbId={item.id}
                href={item.href}
                target={item.target}
                gnbKind={item.gnbKind}
                onClick={() => handleClickGnb(item.id)}>
                <span>{item.label}</span>
              </GnbItem>
            </S.MenuItem>
          ))}
        </S.Menu>
      </S.ContentsWrapper>
    </ModalBase>
  );
}
